const reportsTutorial = {
  module: 'reports',
  moduleName: 'Reports',
  steps: [
    { target: '.reports-header', position: 'bottom', title: 'Reports', description: 'Generate, schedule, and export security reports.' },
    { target: '.reports-header-actions', position: 'bottom', title: 'Actions', description: 'Create new reports, download as PDF or Excel, and manage schedules.' },
  ],
};
export default reportsTutorial;
